// extracted by mini-css-extract-plugin
export var playButton = "MobileShowreelLauncher-module--playButton--qP9Pk";
export var videoOverlay = "MobileShowreelLauncher-module--videoOverlay--eRz18";
export var isPlaying = "MobileShowreelLauncher-module--isPlaying--vj3G6";
export var video = "MobileShowreelLauncher-module--video--RjPgD";